module.exports = __webpack_public_path__ + "img/6_37.5d6a4fad.png";